import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
		min: 'error.required',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
});

export const CatalogAddressSchema = yup.object().shape({
	addressLine: yup.string().required(),
	startNumber: yup.string().required(),
	endNumber: yup.string().required(),
	comment: yup.string(),
});
